const Backdrop = {
    28: "https://image.tmdb.org/t/p/w500/5YZbUmjbMa3ClvSW1Wj3D6XGolb.jpg",
    12: "https://image.tmdb.org/t/p/w500/yF1eOkaYvwiORauRCPWznV9xVvi.jpg",
    16: "https://image.tmdb.org/t/p/w500/jZIYaISP3GBSrVOPfrp98AMa8Ng.jpg",
    35: "https://image.tmdb.org/t/p/w500/gtDuUEprJkTIrzcO2vFsXgdkJ0R.jpg",
    80: "https://image.tmdb.org/t/p/w500/fgw4rFs4XMWdJTWp1eMacHKQqbZ.jpg",
    99: "https://image.tmdb.org/t/p/w500/1yFmxvVYgVrFKL2ksFzgX0MrWOM.jpg",
    18: "https://image.tmdb.org/t/p/w500/rLb2cwF3Pazuxaj0sRXQ037tGI1.jpg",
    10751: "https://image.tmdb.org/t/p/w500/ewUqXnwiRLhgmGhuksOdLgh49Ch.jpg",
    14: "https://image.tmdb.org/t/p/w500/2u7zbn8EudG6kLlBzUYqP8RyFU4.jpg",
    36: "https://image.tmdb.org/t/p/w500/9argwmXnStxPJK1OPAbXeAtqWcA.jpg",
    27: "https://image.tmdb.org/t/p/w500/bylGn5OC2h3BWfGLYFtIcxlYxLy.jpg",
    10402: "https://image.tmdb.org/t/p/w500/oVD3ClJBoomSQHtnJPAlMfes8YD.jpg",
    9648: "https://image.tmdb.org/t/p/w500/veXdzn7LL0bFIDGmE7tTkvRg0qV.jpg",
    10749: "https://image.tmdb.org/t/p/w500/2VnghbG2qWChcE6CdZBMDtDQKCF.jpg",
    878: "https://image.tmdb.org/t/p/w500/vm8mhrjk5nQ562UQ0KbUzi0yOHr.jpg",
    53: "https://image.tmdb.org/t/p/w500/1R6cvRtZgsYCkh8UFuWFN33xBP4.jpg",
    10752: "https://image.tmdb.org/t/p/w500/yizL4cEKsVvl17Wc1mGEIrQtM2F.jpg",
    37: "https://image.tmdb.org/t/p/w500/pVVobDO8cezhVPvwD6EBUN0g3mt.jpg",
}

export default Backdrop